import(/* webpackMode: "eager" */ "C:\\manish-works\\touches\\lokbharti\\Lokbharati\\app\\school-admission\\page.tsx");
